"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var tema_1 = require("../../tema");
var IndicadorDeCarregamento_1 = __importDefault(require("../IndicadorDeCarregamento"));
var classnames_1 = __importDefault(require("classnames"));
var VariacaoDoBotao;
(function (VariacaoDoBotao) {
  VariacaoDoBotao["bordado"] = "bordado";
  VariacaoDoBotao["delineado"] = "delineado";
  VariacaoDoBotao["secundario"] = "secundario";
  VariacaoDoBotao["terciario"] = "terciario";
  VariacaoDoBotao["transparente"] = "transparente";
  VariacaoDoBotao["apoio"] = "apoio";
})(VariacaoDoBotao || (VariacaoDoBotao = {}));
var BotaoCarregando = function () {
  return react_1.default.createElement(rebass_1.Flex, {
    sx: {
      alignItems: "center",
      ".indicador-de-carregamento": {
        mr: 1
      }
    }
  }, react_1.default.createElement(IndicadorDeCarregamento_1.default, null), " Carregando");
};
exports.default = function (_a) {
  var _b;
  var desabilitado = _a.desabilitado,
    estaCarregando = _a.estaCarregando,
    children = _a.children,
    variant = _a.variant,
    onClick = _a.onClick,
    className = _a.className,
    outrasPropriedadesDoBotao = __rest(_a, ["desabilitado", "estaCarregando", "children", "variant", "onClick", "className"]);
  return react_1.default.createElement(tema_1.Tema, null, react_1.default.createElement(rebass_1.Button, __assign({
    className: classnames_1.default((_b = {
      carregando: estaCarregando
    }, _b[variant] = true, _b), className),
    disabled: desabilitado,
    onClick: estaCarregando ? undefined : onClick
  }, outrasPropriedadesDoBotao), estaCarregando ? react_1.default.createElement(BotaoCarregando, null) : children));
};